<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<!-- ticket-message.component -->
<!-- Just put up a place holder for now -->
<div *ngIf="message" class="ticket-message">
	<span
		[@fadeIn]
		*ngIf="deadTimePassed"
		[shakeAnimation]="bounceMessage"
		animationClass="blink-2"
		style="display: block"
		>{{ message }}</span
	>
</div>
